import { render } from "./Select.vue?vue&type=template&id=465aa817"
import script from "./Select.vue?vue&type=script&lang=js"
export * from "./Select.vue?vue&type=script&lang=js"
script.render = render

export default script